import {
  SelectInstitution,
  SelectManagementScopeUnit,
} from "SuperAdmin/Components";
import { formItemLayout } from "SuperAdmin/Config/FormLayout";
import {
  facultyProfilePermissions,
  unitPermissions,
} from "SuperAdmin/Config/Permissions";
import { Button, Checkbox, Form, Radio } from "antd";
import { getSearchInstitutions } from "Explore/Services/Institution";
import styles from "./Form.module.scss";

const FormCreateRole = ({ form, type, onFinishForm, institution }) => {
  return (
    <div className={styles["create-role-form"]}>
      <Form
        {...formItemLayout}
        form={form}
        onFinish={onFinishForm}
        layout="vertical"
      >
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Type:"}
          labelAlign="left"
          name="type"
        >
          <Radio.Group>
            <Radio value={1}>Institution</Radio>
            <Radio value={2}>Unit</Radio>
          </Radio.Group>
        </Form.Item>
        {type == 1 && (
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Management scope:"}
            labelAlign="left"
            name="management_scope_id"
          >
            <SelectInstitution
              placeholder={"Search for institution"}
              functionSearch={getSearchInstitutions}
              form={form}
            />
          </Form.Item>
        )}
        {type == 2 && (
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Institution:"}
            labelAlign="left"
            name="institution_id"
          >
            <SelectInstitution
              placeholder={"Search for institution"}
              functionSearch={getSearchInstitutions}
              form={form}
            />
          </Form.Item>
        )}
        {type == 2 && (
          <Form.Item
            rules={[
              {
                required: true,
              },
            ]}
            label={"Management scope:"}
            labelAlign="left"
            name="management_scope_id"
          >
            <SelectManagementScopeUnit
              placeholder={"Search for unit"}
              form={form}
              filter={[form.getFieldValue("management_scope_name")]}
              entity={""}
            />
          </Form.Item>
        )}
        <Form.Item
          style={{ display: "none" }}
          name="management_scope_name"
        ></Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Unit permissions:"}
          labelAlign="left"
          name="unit_permissions"
        >
          <Checkbox.Group
            options={unitPermissions}
            defaultValue={unitPermissions[0].value}
          />
        </Form.Item>
        <Form.Item
          rules={[
            {
              required: true,
            },
          ]}
          label={"Faculty profile permissions:"}
          labelAlign="left"
          name="faculty_profile_permission"
        >
          <Checkbox.Group
            options={facultyProfilePermissions}
            defaultValue={facultyProfilePermissions[0].value}
          />
        </Form.Item>
        <div className={styles["create-button"]}>
          <Button htmlType="submit" type="primary">
            Create
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormCreateRole;
